const RECAPTCHA_PROD_KEY = '6Lf11hkUAAAAAChIm_uOYzZK4MRNlblRpcC70c6c'
const RECAPTCHA_DEV_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

const prodHostnames = [
  'claimuploadcenter.travelers.com',
  'travelers.com',
  'www.travelers.com',
  'claim.travelers.com'
]

const qaHostnames = [
  'travelers-qa.travelers.com',
  'claimuploadcenter-travelers-qa.travelers.com',
  'claim-mo.travelers.com'
]

const getReCaptchaKey = (hostname: string) => {
    if (prodHostnames.includes(hostname) || qaHostnames.includes(hostname)) {
      return RECAPTCHA_PROD_KEY
    }

    return RECAPTCHA_DEV_KEY
}

const getTealiumUrl = (hostname: string) => {
  let tealiumEnv
  if (prodHostnames.includes(hostname)) {
    tealiumEnv = 'prod'
  } else {
    tealiumEnv = 'dev'
  }

  return `https://tags.tiqcdn.com/utag/travelers/claim-file-uploader/${tealiumEnv}/utag.js`
}

const supplementRequestsHelp =
  `<p>
    If you're a repair facility and need to submit documentation, photos or additional information
    to support a supplement request, visit the supplement portal now.
    <br/>
    <br/>
    Failure to use the supplement portal for your request may cause delays.
  </p>`

const photoCaptureHelp =
  `<p>
    Have you been instructed to submit your photos via a link through text or email?
    <br/>
    <br/>
    Use the link sent to you mobile device or email to complete the photo capture process.
    <br/>
    <br/>
    If not, stay here to proceed with uploading your files.
  </p>`

export { getReCaptchaKey, getTealiumUrl, photoCaptureHelp, supplementRequestsHelp }
